
const ErrorPage = ({icon, text="Une erreur s'est produite"})=>{

    return (
        <div class="flex justify-center items-center h-screen backdrop-blur-md">
            <div className="flex-col justify-center items-center space-y-4">
                <div className="flex justify-center self-center item-center">
                {icon && icon}
                </div>

                {text && <p>{text}</p>}
            </div>
        </div>
    )
}

export default ErrorPage